import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import PaginatedItems from "./pagination";
import { getAdminDashboardCertData, getAdminDashboardCSV } from "../../api/server";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { downloadCSVBlob } from "../../common/downloadCSV";
import gladeBadge from "../../assets/images/glade-badge.png";

const CertificateIssued = () => {
  const [certificateFilter, setCertificateFilter] = useState("Month");
  const [cardDataAllCertificate, setCardDataAllCertificate] = useState();
  const [cardDataCertificate, setCardDataCertificate] = useState();
  const [cardLoadingCertificate, setCardLoadingCertificate] = useState(false);
  const [pageNoCertificate, setPageNoCertificate] = useState(1);
  const [totalCertificate, setTotalCertificate] = useState();
  const [totalIssuedCertificate, setTotalIssuedCertificate] = useState();
  const [statCourseCertificate, setStatCourseCertificate] = useState("All");
  const [filterLoading, setFilterLoading] = useState(false);
  const [cSVLoadingCertificate, setCSVLoadingCertificate] = useState(false);

  // ✅ Validation Schema
  const validationSchema = Yup.object({
    startCert:
      certificateFilter === "Date"
        ? Yup.date().required("Start date is required")
        : Yup.date(),
    endCert:
      certificateFilter === "Date"
        ? Yup.date()
            .required("End date is required")
            .min(Yup.ref("startCert"), "End date must be greater than start")
        : Yup.date(),
  });

  const {
    handleChange,
    touched,
    values,
    errors,
    handleSubmit,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      startCert: "",
      endCert: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: () => {
      fetchDataCertificate();
    },
  });

  // ✅ Fetch Data
  const fetchDataCertificate = async () => {
    if (
      certificateFilter === "Date" &&
      (values.startCert === "" || values.endCert === "")
    ) {
      return;
    }
    setCardLoadingCertificate(true);
    try {
      const res = await getAdminDashboardCertData(
        certificateFilter === "Date"
          ? "certDate"
          : certificateFilter === "Today"
          ? "certToday"
          : "certThis" + certificateFilter,
        statCourseCertificate,
        certificateFilter === "Date"
          ? `&startDate=${values.startCert}&endDate=${values.endCert}`
          : ""
      );

      const data = res.data.data;
      const newTotal = res.data.data.length;
      setCardDataAllCertificate(data);
      setCardDataCertificate(data.slice(0, 10));
      setPageNoCertificate(1);
      setTotalCertificate(newTotal);
      setTotalIssuedCertificate(res?.data?.totalIssuedCert);
    } catch (err) {
      toast.error(
        err.response?.data?.error || "Error fetching certificate data"
      );
    } finally {
      setCardLoadingCertificate(false);
      setFilterLoading(false);
    }
  };

  // ✅ Download CSV
  const downloadCSV = async (setLoading, values) => {
    setLoading(true);
    try {
      const res = await getAdminDashboardCSV(values);
      downloadCSVBlob(res.data, `Certificate-${values.range}-${values.course}.csv`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Error downloading CSV");
    } finally {
      setLoading(false);
    }
  };

  // ✅ useEffect triggers
  useEffect(() => {
    if (certificateFilter !== "Date") {
      setValues({ ...values, startCert: "", endCert: "" });
    }
    fetchDataCertificate();
  }, [certificateFilter, statCourseCertificate]);

  useEffect(() => {
    if (cardDataAllCertificate && cardDataAllCertificate.length > 0) {
      if (certificateFilter !== "Date") {
        setValues({ ...values, startCert: "", endCert: "" });
      }
      setCardLoadingCertificate(true);
      const data = cardDataAllCertificate.slice(
        (pageNoCertificate - 1) * 10,
        pageNoCertificate * 10
      );
      const newTotal = cardDataAllCertificate.length;
      setTimeout(() => {
        setCardLoadingCertificate(false);
        setFilterLoading(false);
        setCardDataCertificate(data);
        setTotalCertificate(newTotal);
      }, 300);
    }
  }, [pageNoCertificate]);

  return (
    <>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content">
          <DashboardNavbar />
          <section className="manage-students language_wrap dasboard">
           <div className="col-lg-12 mt-4">
            {certificateFilter === "Date" && (
              <form
                className="row align-items-center mt-5"
                onSubmit={handleSubmit}
              >
                <h6 className="fw-bold text-center col-2 mb-4">
                  <span className="text_success">Date Range:</span>
                </h6>
                <div className="col-3">
                  <div className="input_wrap" style={{ marginBottom: "0px" }}>
                    <label className="label-title">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ height: "50px" }}
                      placeholder="Enter start date"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="startCert"
                      value={values.startCert}
                    />
                    <p className="text-danger mb-0" style={{ minHeight: "25px" }}>
                      {errors.startCert && touched.startCert ? errors.startCert : ""}
                    </p>
                  </div>
                </div>
                <div className="col-2 d-flex align-items-center justify-content-center">
                  <div className="form-group">
                    <label className="label-title">To</label>
                  </div>
                </div>
                <div className="col-3">
                  <div className="input_wrap" style={{ marginBottom: "0px" }}>
                    <label className="label-title">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ height: "50px" }}
                      placeholder="Enter end date"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="endCert"
                      value={values.endCert}
                    />
                    <p className="text-danger mb-0" style={{ minHeight: "25px" }}>
                      {errors.endCert && touched.endCert ? errors.endCert : ""}
                    </p>
                  </div>
                </div>
                <div className="text-center col-2 mb-4">
                  <button
                    className="btn_brnd"
                    disabled={filterLoading}
                    type="submit"
                  >
                    {filterLoading ? (
                      <ThreeDots
                        height="20"
                        width="60"
                        radius="9"
                        color="#4fa94d"
                        ariaLabel="three-dots-loading"
                        visible={true}
                      />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            )}

            <div className="card" style={{ height: "auto" }}>
              <div className="card-body certificateTableWrapper">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between" style={{ width: "35%" }}>
                    <h3
                      style={{
                        fontWeight: "bold",
                        fontSize: "22px",
                        textTransform: "capitalize",
                        marginBottom: "0px",
                      }}
                    >
                      Certificate Issued
                    </h3>
                    { totalIssuedCertificate > 0 && (
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#555",
                          padding: "0 10px",
                          marginBottom: "0px",
                        }}
                      >
                        Total:{" "}
                        <span style={{ fontWeight: "600", color: "#000" }}>
                          {totalIssuedCertificate}
                        </span>
                      </p>
                    )}
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      className="btn_brnd"
                      style={{ padding: "6px 30px", fontWeight: "500", width: "155px" }}
                      type="button"
                      disabled={cSVLoadingCertificate}
                      onClick={() => {
                        downloadCSV(setCSVLoadingCertificate, {
                          course: statCourseCertificate,
                          range: certificateFilter,
                          type: "Certificate",
                          startDate: certificateFilter === "Date" ? values.startCert : null,
                          endDate: certificateFilter === "Date" ? values.endCert : null,
                        });
                      }}
                    >
                      {cSVLoadingCertificate ? (
                        <ThreeDots
                          height="20"
                          width="94"
                          radius="9"
                          color="#4fa94d"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{ display: "block" }}
                          wrapperClassName="spinner"
                          visible={true}
                        />
                      ) : (
                        "Export Data"
                      )}
                    </button>

                    <select
                      className="form-select ms-4"
                      style={{ width: "150px" }}
                      value={certificateFilter}
                      onChange={(e) => {
                        setCertificateFilter(e.target.value);
                        setCardDataAllCertificate();
                        setPageNoCertificate(1);
                      }}
                    >
                      <option value="Today">Today</option>
                      <option value="Week">Week</option>
                      <option value="Month">Month</option>
                      <option value="Date">Custom Range</option>
                    </select>

                    <select
                      className="form-select ms-4"
                      style={{ width: "150px" }}
                      value={statCourseCertificate}
                      onChange={(e) => {
                        setStatCourseCertificate(e.target.value);
                        setCardDataAllCertificate();
                        setPageNoCertificate(1);
                      }}
                    >
                      <option value="CC">CC</option>
                      <option value="DE">DE</option>
                      <option value="All">All</option>
                    </select>
                  </div>
                </div>

                <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                  <table className="table table-borderless table-responsive mt-4">
                    <thead>
                      <tr>
                        <th style={{ width: "28%" }}>Name</th>
                        <th style={{ width: "28%" }}>Email</th>
                        <th style={{ width: "24%" }}>Certificate Issued</th>
                        <th style={{ width: "20%" }}>Issue Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cardLoadingCertificate ? (
                        <tr>
                          <td colSpan={4}>
                            <ThreeDots
                              height="40"
                              width="80"
                              radius="9"
                              color="#4fa94d"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{ display: "flex", justifyContent: "center" }}
                              wrapperClassName="spinner"
                              visible={true}
                            />
                          </td>
                        </tr>
                      ) : cardDataCertificate && cardDataCertificate.length > 0 ? (
                        cardDataCertificate.map((item, index) => (
                          <tr key={item.isGlade ? `glade-${item.id}-${item.certificateCourse}-${item.courseId}` : `evergreen-${index}`}>
                           <td>
                                  <p style={{marginBottom:'0px'}}>
                                    <Link
                                      to={item.isGlade ? `/glade-client-details?id=${item.id}` : `/editstudent?id=${item.id}`}
                                      style={{
                                        color: "rgba(12, 25, 34, 0.4)",
                                      }}
                                    >
                                      <div className="flex-i gAddBox__row" style={{flexWrap: 'wrap', whiteSpace: 'nowrap' }}>
                                      {item.isGlade ? (
                                        <>
                                          <span>{item.filerType === "Joint"
                                            ? `${item.joint_firstname || ""} ${item.joint_lastname || ""} (Joint)`
                                            : `${item.firstname || ""} ${item.lastname || ""}`}</span>
                                          <img className="glade-source-badge" src={gladeBadge} alt="Glade" title="Glade client" />
                                        </>
                                      ) : statCourseCertificate === "CC" ? (
                                        item.courseFirstType === "Main" ? (
                                          <>
                                            <p style={{marginBottom:'0'}}>{item.firstname} {item.lastname}</p>
                                            {(item.joint_firstname || item.joint_lastname) && (
                                              <>({item.joint_firstname} {item.joint_lastname} <i className="fas fa-user-friends" style={{ marginLeft: '4px', color: 'gray' }}></i>) </>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <p style={{marginBottom:'0'}}>{item.joint_firstname} {item.joint_lastname}</p>
                                            {(item.joint_firstname || item.joint_lastname) && " (Joint)"}
                                          </>
                                        )
                                      ) : statCourseCertificate === "DE" ? (
                                        item.courseSecondType === "Main" ? (
                                          <>
                                            <p style={{marginBottom:'0'}}>{item.firstname} {item.lastname}</p>
                                            {(item.joint_firstname || item.joint_lastname) && (
                                              <> ({item.joint_firstname} {item.joint_lastname} <i className="fas fa-user-friends" style={{ marginLeft: '4px', color: 'gray' }}></i>)</>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {item.joint_firstname} {item.joint_lastname}
                                            {(item.joint_firstname || item.joint_lastname) && " (Joint)"}
                                          </>
                                        )
                                      ) : statCourseCertificate === "All" ? (
                                        item.courseFirstType === "Main" && item.courseSecondType === "Main" ? (
                                          <>
                                            <p style={{marginBottom:'0'}}>{item.firstname} {item.lastname}</p>
                                            {(item.joint_firstname || item.joint_lastname) && (
                                              <> ({item.joint_firstname} {item.joint_lastname} <i className="fas fa-user-friends" style={{ marginLeft: '4px', color: 'gray' }}></i>)</>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {item.joint_firstname} {item.joint_lastname}
                                            {(item.joint_firstname || item.joint_lastname) && "(Joint)" }
                                          </>
                                        )
                                      ) : (
                                        ""
                                      )}
                                        {/* {item.firstname} {item.lastname} {item.courseSecondType == "Joint" ? "(Joint)" : item.courseFirstType == "Joint" ? "(Joint)" : ""} */}
                                        {item?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                                      </div>
                                    </Link>

                                  </p>
                                </td>
                                <td>
                                  <div className="media">
                                    <div className="media-body">
                                      <a href={`mailto:${item.email}`}>
                                        {item.email}
                                      </a>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="media">
                                    <div className="media-body">
                                      {item.certificateCourse}
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="media">
                                    <div className="media-body">
                                      {item.certificateCourse === "CC"
                                        ? "CC: " +
                                        item.certificateDateCC?.split("T")[0]
                                        : item.certificateCourse === "DE"
                                          ? "DE: " +
                                          item.certificateDateDE?.split("T")[0]
                                          : item.certificateCourse === "CC & DE"
                                            ? "CC: " +
                                            item.certificateDateCC?.split(
                                              "T"
                                            )[0] +
                                            ", DE: " +
                                            item.certificateDateDE?.split("T")[0]
                                            : ""}
                                    </div>
                                  </div>
                                </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} style={{ textAlign: "center", marginTop: "10px" }}>
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {!cardLoadingCertificate && totalCertificate > 10 && (
                  <PaginatedItems
                    total={totalCertificate}
                    pageNo={pageNoCertificate}
                    setPageNo={setPageNoCertificate}
                    pageSize={10}
                  />
                )}
              </div>
            </div>
          </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CertificateIssued;


